import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Save from './save';
import Edit from './Edit';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
				fill="currentColor"
			>
				{ /* Horizontal arrows representing scrolling motion */ }
				<path d="M2 12l3-3v2h14v-2l3 3-3 3v-2H5v2z" />
				<rect x="1" y="5" width="22" height="1" rx="0.5" opacity="0.3" />
				<rect x="1" y="18" width="22" height="1" rx="0.5" opacity="0.3" />
			</svg>
		),
	},
} );
